import { useApi } from '@micromag/data';
import { useCallback } from 'react';

import useItems from './useItems';

const useStoryLastPublication = (storyId, query = null, opts = {}) => {
    const api = useApi();
    const { disabled = false } = opts || {};
    const getItems = useCallback(
        (requestedPage = null) => api.stories.publications.get(storyId, query, requestedPage, 1),
        [api, storyId, query, 1],
    );
    const { items, ...request } = useItems({
        getItems: !disabled ? getItems : null,
        ...opts,
    });
    const [item = null] = items || [];
    return {
        lastPublication: item,
        ...request,
    };
};

export default useStoryLastPublication;
